import React from 'react';
import UploadImage from '../../../../components/UploadImage/UploadImage';
import ProductRepository from '../../../../repositories/ProductRepository';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedIncompletedProduct } from '../../redux/Reducer';

const UploadImgIncomplete = () => {
    const dispatch = useDispatch();
    const selectedIncompletedProduct = useSelector((state) => state.reducer.selectedIncompletedProduct);

    // Ensure imageUrl is initialized as an array of 5 empty strings
    const imageUrl = selectedIncompletedProduct.imageUrl || ['', '', '', '', ''];

    const base64ToBlob = (base64String, contentType = 'image/png') => {
        const base64Data = base64String.replace(/^data:image\/[a-z]+;base64,/, '');
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    };

    const uploadProductImageTemp = async (file) => {
        try {
            const form = new FormData();
            form.append('file', file);
            const response = await ProductRepository.uploadProductImageTemp(form);
            return response.data.data ?? '';
        } catch (error) {
            console.log('error:', error);
            return '';
        }
    };

    // Determine if an UploadImage at index is disabled for uploading
    const isUploadDisabled = (index) => {
        if (index === 0) return false;
        return !imageUrl.slice(0, index).every((url) => url && url.trim() !== '');
    };

    // Find the last filled index (last non-empty URL)
    const getLastFilledIndex = () => {
        let lastIndex = -1;
        imageUrl.forEach((url, idx) => {
            if (url && url.trim() !== '') {
                lastIndex = idx;
            }
        });
        return lastIndex;
    };

    // Determine if deletion is allowed at the given index
    const isDeleteDisabled = (index) => {
        const lastFilledIndex = getLastFilledIndex();
        return index !== lastFilledIndex;
    };

    return (
        <div className="flex flex-row gap-x-2 bg-gray-disable rounded-xl p-2">
            {[...Array(5)].map((_, index) => (
                <div key={index} className="relative">
                    <UploadImage
                        isDisableDeleted={isDeleteDisabled(index)}
                        img={imageUrl[index] || ''}
                        aspectRatio={1 / 1}
                        name={`photo${index + 1}`}
                        width={40}
                        height={40}
                        position="col"
                        disabled={isUploadDisabled(index)} // Disable upload if out of sequence
                        onClick={async (photo, name) => {
                            if (isUploadDisabled(index)) {
                                console.warn(`Cannot upload at index ${index}: previous slots are not filled.`);
                                return;
                            }
                            try {
                                const blob = base64ToBlob(photo);
                                const file = new File([blob], `${name}.png`, { type: 'image/png' });
                                const url = await uploadProductImageTemp(file);
                                if (url) {
                                    const updatedImageUrl = [...imageUrl];
                                    updatedImageUrl[index] = url;
                                    dispatch(
                                        setSelectedIncompletedProduct({
                                            ...selectedIncompletedProduct,
                                            imageUrl: updatedImageUrl,
                                        })
                                    );
                                }
                            } catch (error) {
                                console.error('error:', error);
                            }
                        }}
                        onDelete={(imageRef) => {
                            if (isDeleteDisabled(index)) {
                                console.warn(`Cannot delete at index ${index}: only the last filled image can be deleted.`);
                                return;
                            }
                            if (imageRef.current) {
                                imageRef.current.value = null;
                                const updatedImageUrl = [...imageUrl];
                                updatedImageUrl[index] = ''; // Clear the URL
                                dispatch(
                                    setSelectedIncompletedProduct({
                                        ...selectedIncompletedProduct,
                                        imageUrl: updatedImageUrl,
                                    })
                                );
                            }
                        }}
                    />
                    {isUploadDisabled(index) && (
                        <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-md">
                            <span className="text-white text-xs">Fill previous slot first</span>
                        </div>
                    )}
                    {/* {imageUrl[index] && isDeleteDisabled(index) && (
                        <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-md">
                            <span className="text-white text-xs">Only last image can be deleted</span>
                        </div>
                    )} */}
                </div>
            ))}
        </div>
    );
};

export default UploadImgIncomplete;